export enum RegisterModeConfigEnum {
  BETA_USER = 'BETA_USER',
  ALL = 'ALL',
}
